// @ts-check

import { safeProfilePic } from '~/other/Helper';
import UserPopoverCard from '~/components/Shared/UserPopoverCard';

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function SingleAvatarCell({value: user}) {
    if (!user) {
        return null;
    }

    return (
        <UserPopoverCard user={user}>
            <span style={{ cursor: "pointer" }}>
                {safeProfilePic(user, "img-sm img-circle bulletin", "bulletin", {
                    marginRight: "5px",
                    display: "inline-block",
                })}
            </span>
        </UserPopoverCard>
    );
}